var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Icon } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import React, { Component } from "react";
var MenuButton = /** @class */ (function (_super) {
    __extends(MenuButton, _super);
    function MenuButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuButton.prototype.render = function () {
        return (React.createElement(IconButton, { onClick: this.props.handleMouseDown, className: "hide-on-large-only menuButton" },
            React.createElement(Icon, { className: "menuIcon" }, "menu")));
    };
    return MenuButton;
}(Component));
export default MenuButton;



//////////////////
// WEBPACK FOOTER
// ./src/components/layout/MenuButton.tsx
// module id = 1011
// module chunks = 0